module.exports = __webpack_public_path__ + "static/media/lt.bcfd9fd3.svg";